export const UNIT_CONVERSIONS = {
  weight: {
    baseUnit: "g",
    conversions: {
      kg: 1000,
      g: 1,
      oz: 28.3495,
      lbs: 453.592,
      lb: 453.592,
      pound: 453.592,
      pounds: 453.592
    }
  },
  volume: {
    baseUnit: "ml",
    conversions: {
      l: 1000,
      ml: 1,
      tbsp: 15,
      tsp: 5,
      cup: 240,
      cups: 240,
      floz: 29.5735,   
      "fl oz": 29.5735,   // fixed U.S. fluid ounce abbreviation
      "fluid ounce": 29.5735,
      "fluid ounces": 29.5735,
      pint: 473.176,
      quart: 946.353,
      gallon: 3785.41     // added gallon
    }
  },
  count: {
    baseUnit: "piece",
    conversions: {
      piece: 1,
      pieces: 1,
      slice: 1,
      slices: 1,
      clove: 1,
      cloves: 1,
      head: 1,
      unit: 1,
      units: 1,
      whole: 1,
      carton: 1,
      pack: 1,
      dozen: 12,
      bunch: 1,
      spear: 1,
      leaf: 1,
      leaves: 1,
      medium: 1
    }
  }
};

// Default unit conversions for special units
export const DEFAULT_UNIT_CONVERSIONS = {
  units: "piece",
  unit: "piece",
  slices: "slice",
  slice: "slice",
  cloves: "clove",
  clove: "clove",
  pinch: "pinch",
  taste: "to taste",
  bunch: "bunch",
  spear: "spear",
  spears: "spear",
  leaf: "leaf",
  leaves: "leaf",
  carton: "carton",
  pack: "pack",
  medium: "medium"
};

// Common food densities (g/ml) for conversion between volume and weight
export const FOOD_DENSITIES = {
  "flour": 0.55,        // 1 cup ≈ 130g
  "sugar": 0.85,        // 1 cup ≈ 200g
  "rice": 0.75,         // 1 cup ≈ 180g
  "rolled oats": 0.35,  // 1 cup ≈ 85g
  "milk": 1.03,
  "oil": 0.92,
  "olive oil": 0.92,
  "honey": 1.42,
  "yogurt": 1.05,
  "greek yogurt": 1.10, // slightly denser
  "butter": 0.96,
  "water": 1.0,
  "spinach": 0.125,     // 1 cup fresh spinach ≈ 30g
  "mixed greens": 0.125, // similar to spinach
  "almonds": 0.46,      // 1 cup ≈ 110g
  "granola": 0.40,      // 1 cup ≈ 100g
  "strawberries": 0.6,   // 1 cup ≈ 144g
  "salt": 1.20,           // 1 ml ≈ 1.2 g  (поваренная соль)
  "cinnamon": 0.56,       // 1 cup ground ≈ 132 g
  "mixed berries": 0.65,  // 1 cup ≈ 155 g
  "cilantro": 0.05,       // 1 cup chopped ≈ 12 g
  "brown rice": 0.80,      // 1 cup ≈ 190 g
  "lettuce": 0.1,
  "mixed salad greens": 0.1
};

export const FOOD_SYNONYMS = {
  // --- Produce ---
  "tomatoes": ["tomato", "fresh tomatoes", "roma tomato", "plum tomatoes", "large tomato", "Томат Бифштекс", "Томаты Сливовидные", "Томат Розовый", "Томаты на ветке"],
  "cherry-tomatoes": ["cherry tomatoes", "grape tomatoes", "small tomatoes", "Томаты черри", "Томаты черри на ветке"],
  "potatoes": ["potato", "baking potatoes", "russet potatoes", "white potatoes", "Картофель"],
  "onions": ["onion", "yellow onion", "white onion", "red onion", "Лук репчатый"],
  "carrots": ["carrot", "orange carrots", "baby carrots", "Морковь"],
  "cucumber": ["cucumbers", "english cucumber", "fresh cucumber", "Огурец"],
  "bell-peppers": ["bell pepper", "red pepper", "green pepper", "yellow pepper", "pimiento", "Перец зеленый", "Перец красный", "Перец желтый"],
  "broccoli": ["broccoli", "fresh broccoli", "green broccoli", "brócoli", "Брокколи"],
  "zucchini": ["courgette", "green squash", "summer squash", "calabacín", "Кабачок"],
  "sweet-potatoes": ["sweet potato", "sweet potatoes", "yam", "boniato", "Батат"],
  "eggplant": ["eggplant", "aubergine", "purple eggplant", "berenjena", "Баклажан"],
  "lemons": ["lemon", "lemons", "limones", "Лимоны"],
  "mushrooms": ["mushroom", "white mushrooms", "cremini mushrooms", "button mushrooms", "champiñones", "Шампиньоны"],
  "garlic": ["garlic head", "garlic clove", "fresh garlic", "ajos", "cabeza de ajo", "Чеснок"],
  "ginger": ["ginger root", "fresh ginger", "jengibre", "Корень имбиря"],
  "parsley-fresh": ["parsley", "italian parsley", "flat leaf parsley", "curly parsley", "perejil fresco", "Петрушка свежая"],
  "fresh-strawberries": ["fresh strawberries", "strawberries", "fresas", "Свежая клубника"],
  "fresh-blueberries": ["fresh blueberries", "blueberries", "arándanos", "Свежая голубика"],
  "avocado": ["avocados", "avocado", "hass avocado", "Авокадо"],
  "broccoli-florets-fresh": ["broccoli florets", "fresh broccoli florets", "chopped broccoli", "brócoli en ramilletes", "Соцветия брокколи свежие"],
  "lettuce": ["romaine lettuce", "iceberg lettuce", "lettuce head", "Салат Айсберг"],
  "fresh-basil": ["basil", "sweet basil", "basil leaves", "fresh herbs", "Базилик свежий"],
  "bananas": ["banana", "plátano", "Бананы"],
  "apples": ["apple", "manzana", "Яблоки"],
  "oranges": ["orange", "naranja", "Апельсины"],
  "asparagus": ["asparagus", "fresh asparagus", "Спаржа"],
  "cilantro-fresh": ["cilantro", "fresh cilantro", "coriander leaves", "fresh coriander", "Кинза свежая"],
  "lime": ["lime", "limes", "Лайм"],
  "cabbage": ["cabbage", "green cabbage", "white cabbage", "Капуста белокочанная"],
  "spinach-fresh": ["spinach", "fresh spinach", "Шпинат свежий"],
  "mixed-berries-fresh": ["mixed berries", "fresh berry mix", "berry medley", "Ягодная смесь свежая"],

  // --- Meat & Seafood ---
  "chicken-whole": ["whole chicken", "pollo entero", "Курица целая"],
  "chicken-breast": ["chicken", "chicken breast", "boneless chicken", "chicken fillet", "pechuga de pollo", "Филе куриной грудки"],
  "chicken-thighs": ["chicken thighs", "muslos de pollo", "chicken leg quarters", "Куриные бедра"],
  "pork-loin-fillets": ["pork chops", "pork loin", "pork cuts", "filetes de lomo de cerdo", "Филе свиной вырезки"],
  "minced-beef": ["beef mince", "minced beef", "ground beef", "carne picada de vacuno", "Фарш говяжий"],
  "sausages-pork-fresh": ["fresh pork sausages", "salchichas frescas de cerdo", "pork sausages", "Сосиски свежие свиные"],
  "ham-cooked-sliced": ["sliced cooked ham", "jamón cocido en lonchas", "york ham slices", "Ветчина нарезанная"],
  "beef-steak": ["beef steak", "filetes de ternera", "beef slices", "Говяжий стейк"],
  "pork-ribs": ["pork ribs", "costillas de cerdo", "Свиные ребрышки"],
  "salmon-fillet-fresh": ["fresh salmon fillet", "salmón fresco", "filete de salmón fresco", "Филе лосося свежее"],
  "pork-shoulder": ["pork shoulder", "pork butt", "paleta de cerdo", "boston butt", "Свиная лопатка"],
  "beef-chuck": ["beef chuck", "chuck roast", "stewing beef", "carne para guisar", "aguja de ternera", "Говяжья лопатка"],
  "fresh-prawns": ["prawns", "shrimp", "shrimps", "fresh shrimp", "seafood", "Креветки свежие"],
  "mixed-seafood": ["mixed seafood", "seafood mix", "seafood medley", "Морской коктейль"],
  "chorizo": ["chorizo", "spanish sausage", "spicy sausage", "cured meat", "Чоризо"],
  "serrano-ham": ["serrano ham", "jamon serrano", "cured ham", "spanish ham", "jamón", "Хамон Серрано"],
  "white-fish-fillet": ["white fish fillet", "white fish", "sea bass fillet", "cod fillet", "generic fish fillet", "Филе белой рыбы"],
  "mussels": ["mussels", "mussel", "black mussels", "mejillones", "seafood mussels", "Мидии"],
  "calamari": ["calamari", "squid", "squid rings", "fried calamari", "calamares", "Кальмары"],
  "pancetta": ["pancetta", "italian bacon", "Панчетта"],
  "beef-strips": ["beef strips", "strip steak", "sliced beef", "Говядина для бефстроганова"],

  // --- Frozen ---
  "salmon-fillet-frozen": ["frozen salmon fillet", "salmón congelado", "filete de salmón congelado", "Филе лосося замороженное"],
  "sea bass-fillet-frozen": ["frozen sea bass fillets", "merluza congelada", "filetes de merluza", "Филе тилапии замороженное"],
  "prawns-frozen": ["prawns", "frozen shrimp", "seafood", "gambones congelados", "Креветки замороженные"],
  "cod-fillet-frozen": ["frozen cod fillet", "filetes de bacalao ultracongelados", "cod fish frozen", "Филе трески замороженное"],
  "spinach-frozen": ["frozen spinach", "espinacas congeladas", "Шпинат замороженный"],
  "mixed-vegetables-frozen": ["frozen mixed vegetables", "verdura congelada", "menestra congelada", "Овощная смесь замороженная"],
  "green-beans-frozen": ["frozen green beans", "judía verde congelada", "Фасоль стручковая замороженная"],
  "frozen-strawberries": ["frozen strawberries", "strawberries frozen", "fresas congeladas", "Клубника замороженная"],
  "frozen-blueberries": ["frozen blueberries", "blueberries frozen", "arándanos congelados", "Голубика замороженная"],
  "peas-frozen": ["frozen peas", "peas", "garden peas", "guisantes congelados", "Горошек замороженный"],

  // --- Dairy, Alternatives & Eggs ---
  "eggs": ["egg", "medium eggs", "grade m eggs", "huevos", "Яйца", "Яйца крупные L", "Яйца средние M", "Яйца фермерские", "Яйца органические"],
  "milk-whole": ["milk", "whole milk", "full fat milk", "dairy milk", "leche entera", "Молоко цельное"],
  "milk-2percent": ["2% milk", "semi-skimmed milk", "leche semidesnatada", "Молоко 2%"],
  "milk-skim": ["skimmed milk", "leche desnatada", "Молоко обезжиренное"],
  "butter": ["butter", "mantequilla", "salted butter", "unsalted butter", "Масло сливочное"],
  "cheese-sliced": ["sliced cheese", "queso en lonchas", "sandwich cheese", "Сыр нарезанный"],
  "cheese-shredded": ["grated cheese blend", "mixed grated cheese", "queso rallado", "Сыр тертый (смесь 4 сыра)"],
  "cheddar-cheese": ["cheddar cheese", "queso cheddar", "block cheddar", "sliced cheddar", "Сыр чеддер"],
  "parmesan-grated": ["parmigiano", "parmesan", "hard cheese", "grated parmesan", "queso parmesano rallado", "Сыр Пармезан тертый"],
  "cooking-cream": ["cooking cream", "nata para cocinar", "light cream", "Сливки для готовки"],
  "heavy-cream": ["heavy cream", "nata para montar", "whipping cream", "Сливки для взбивания"],
  "yogurt-natural": ["yogurt", "natural yogurt", "plain yogurt", "yogur natural", "Йогурт натуральный"],
  "condensed-milk": ["condensed milk", "leche condensada", "sweetened condensed milk", "Молоко сгущенное"],
  "mozzarella-cheese": ["mozzarella cheese", "mozzarella", "fresh mozzarella", "italian cheese", "pizza cheese", "bola de mozzarella", "Сыр Моцарелла"],
  "cream-cheese": ["cream cheese", "queso crema", "soft cheese", "Сливочный сыр"],
  "greek-yogurt": ["greek yogurt", "strained yogurt", "yogurt", "Греческий йогурт"],
  "tofu": ["tofu", "firm tofu", "extra‑firm tofu", "soy bean curd", "Тофу"],
  "emmental-cheese": ["emmental cheese", "emmental", "swiss cheese", "holey cheese", "Сыр Эмменталь"],
  "feta-cheese": ["feta cheese", "feta", "greek cheese", "crumbly cheese", "Сыр Фета"],

  // --- Bakery ---
  "bread-loaf-sliced": ["white bread", "bread loaf", "sandwich bread", "toast bread", "pan de molde", "Хлеб тостовый"],
  "baguette": ["french bread", "bread stick", "crusty bread", "barra de pan", "Багет"],
  "breadcrumbs": ["breadcrumbs", "pan rallado", "dry breadcrumbs", "Панировочные сухари"],
  "rye-bread-sliced": ["rye bread", "dark rye bread", "pan de centeno", "sliced rye bread", "Хлеб ржаной нарезанной"],
  "croissants": ["croissant", "french pastry", "breakfast pastry", "Круассан"],
  "whole-wheat-bread": ["whole wheat bread", "whole‑grain bread", "grain bread", "wheat bread", "Хлеб цельнозерновой"],
  "ciabatta-bread": ["ciabatta", "ciabatta bread", "ciabatta loaf", "Чиабатта"],

  // --- Refrigerated ---
  "puff-pastry": ["puff pastry sheet", "hojaldre fresco", "pastry dough", "Тесто слоеное"],
  "shortcrust-pastry": ["shortcrust pastry sheet", "masa quebrada fresca", "pâte brisée", "Тесто песочное"],

  // --- Grains & Pasta ---
  "rice-short-grain": ["rice", "round grain rice", "arroz redondo", "Рис круглый"],
  "rice-long-grain": ["long grain rice", "arroz largo", "white rice", "Рис длиннозерный белый"],
  "rice-paella": ["paella rice", "arroz para paella", "arroz bomba", "short grain rice for paella", "Рис для паэльи"],
  "pasta-spaghetti": ["pasta", "spaghetti", "italian pasta", "long pasta", "espagueti", "Спагетти"],
  "pasta-macaroni": ["pasta", "macaroni", "elbow pasta", "short pasta", "macarrones", "Макароны"],
  "pasta-fusilli": ["fusilli pasta", "pasta espirales", "spiral pasta", "dry pasta", "Макароны фузилли"],
  "rice-brown": ["brown rice", "whole‑grain rice", "long‑grain brown rice", "Коричневый рис"],
  "quinoa": ["quinoa", "whole grain quinoa", "white quinoa", "quinoa seeds", "Киноа"],
  "wheat-pasta-generic": ["wheat pasta", "whole wheat pasta", "pasta integral", "whole grain pasta", "Пшеничные макароны"],
  "pasta-whole-wheat": ["wheat pasta", "whole wheat pasta", "pasta integral", "whole grain pasta"],
  "mexican-rice": ["mexican rice", "spanish rice", "mex‑rice mix", "Рис по-мексикански"],
  "arborio-rice": ["arborio rice", "risotto rice", "italian rice", "risotto grain", "Рис Арборио"],

  // --- Pantry ---
  "rolled-oats": ["rolled oats", "copos de avena", "oats", "porridge oats", "Овсяные хлопья"],
  "tuna-in-oil": ["canned tuna in oil", "atún en aceite", "tuna chunks in oil", "Тунец в масле"],
  "tuna-in-brine": ["canned tuna in brine", "atún al natural", "tuna chunks in water", "Тунец в собственном соку"],
  "sardines-canned": ["canned sardines", "sardinas en lata", "sardines in oil", "Сардины в масле"],
  "lentils-cooked": ["cooked lentils", "lenteja cocida", "canned lentils", "Чечевица вареная"],
  "lentils-dry": ["dry lentils", "lenteja seca", "pardina lentils", "Чечевица сухая"],
  "chickpeas-cooked": ["chickpeas", "garbanzo beans", "canned chickpeas", "garbanzo cocido", "Нут вареный"],
  "chickpeas-dry": ["dry chickpeas", "garbanzo seco", "Нут сухой"],
  "white-beans-cooked": ["cooked white beans", "alubia blanca cocida", "canned white beans", "Фасоль белая вареная"],
  "white-beans-dry": ["dry white beans", "alubia blanca seca", "fabada beans dry", "Фасоль белая сухая"],
  "sugar-white": ["sugar", "granulated sugar", "table sugar", "azúcar blanco", "Сахар белый"],
  "sugar-brown": ["brown sugar", "azúcar moreno", "dark brown sugar", "light brown sugar", "Сахар коричневый"],
  "flour-wheat": ["all purpose flour", "plain flour", "baking flour", "harina de trigo", "wheat flour", "Мука пшеничная"],
  "honey": ["honey", "miel", "bee honey", "Мед цветочный"],
  "jam-strawberry": ["strawberry jam", "mermelada de fresa", "fruit preserves", "Варенье клубничное"],
  "green-olives-pitted": ["pitted green olives", "aceitunas verdes sin hueso", "olives canned", "Оливки зеленые без косточек"],
  "tomato-paste-concentrated": ["concentrated tomato paste", "concentrado de tomate", "tomato concentrate", "Томатная паста"],
  "peas-canned": ["canned peas", "guisantes en conserva", "peas in brine", "Горошек консервированный"],
  "sweetcorn-canned": ["canned sweetcorn", "maíz dulce en conserva", "sweetcorn in brine", "Кукуруза консервированная"],
  "stock-cubes-chicken": ["chicken stock cubes", "chicken bouillon cubes", "pastillas de caldo de pollo", "Кубики куриного бульона"],
  "stock-cubes-vegetable": ["vegetable stock cubes", "vegetable bouillon cubes", "pastillas de caldo de verduras", "Кубики овощного бульона"],
  "vanilla-extract": ["vanilla extract", "aroma de vainilla", "vanilla essence", "Ванильный экстракт"],
  "baking-powder": ["baking powder", "levadura en polvo", "Разрыхлитель теста"],
  "cocoa-powder-unsweetened": ["unsweetened cocoa powder", "cacao puro en polvo", "baking cocoa", "Какао-порошок"],
  "almonds": ["almonds", "raw almonds", "shelled almonds", "almendra cruda", "almendras", "Миндаль сырой"],
  "walnuts": ["walnuts", "shelled walnuts", "raw walnuts", "nuez pelada", "nueces", "Грецкие орехи"],
  "hazelnuts": ["hazelnuts", "avellanas", "avellana pelada", "shelled hazelnuts", "Фундук очищенный"],
  "pine-nuts": ["pine nuts", "piñones", "Кедровые орехи"],
  "lemon-juice-bottled": ["lemon juice", "bottled lemon juice", "zumo de limón", "lemon juice concentrate", "Лимонный сок"],
  "vegetable-broth-liquid": ["vegetable broth", "vegetable stock", "veggie broth", "caldo de verduras", "liquid vegetable stock", "Овощной бульон"],
  "peas-dry": ["dried peas", "split peas", "Горох сушеный"],
  "beef-broth-liquid": ["beef broth", "beef stock", "caldo de carne", "liquid beef stock", "Говяжий бульон"],
  "chia-seeds": ["chia seeds", "семена чиа"],
  "olive-oil-extra-virgin": ["olive oil", "extra virgin olive oil", "evoo", "aceite de oliva virgen extra"],
  "dried-kidney-beans": ["dried kidney beans", "red kidney beans", "Красная фасоль сушеная"],
  "chicken-broth": ["chicken stock", "broth", "stock", "caldo de pollo", "Куриный бульон"],
  "coffee-ground": ["coffee", "ground coffee", "café molido", "Кофе молотый"],
  "tea-bags": ["tea", "tea bags", "té", "Чай в пакетиках"],
  "saffron": ["azafrán", "spice", "saffron spice", "saffron threads", "saffron", "Шафран"],
  "cinnamon-ground": ["cinnamon", "ground cinnamon", "cinnamon powder", "Корица молотая"],
  "maple-syrup": ["maple syrup", "Кленовый сироп"],
  "canned-tuna": ["canned tuna", "tuna can", "tuna in water", "tuna in oil"],

  // --- Condiments ---
  "salt": ["salt", "sea salt", "cooking salt", "table salt", "sal marina", "Соль морская мелкая"],
  "black-pepper-ground": ["black pepper", "ground pepper", "pimienta negra molida", "Перец черный молотый"],
  "vinegar-white-wine": ["vinegar", "white wine vinegar", "vinagre de vino blanco", "Уксус винный белый"],
  "mayonnaise": ["mayo", "creamy mayonnaise", "sandwich spread", "mayonesa", "Майонез"],
  "paprika-sweet": ["sweet paprika", "pimentón dulce", "spanish paprika", "Паприка сладкая"],
  "soy-sauce": ["soy sauce", "salsa de soja", "shoyu", "tamari", "Соевый соус"],
  "red-pepper-flakes": ["red pepper flakes", "crushed red pepper", "chilli flakes", "Хлопья красного перца"],
  "herbs-de-provence": ["herbs de provence", "french herbs", "dried herbs", "herb mix", "herb blend", "Прованские травы"],
  "caesar-dressing": ["caesar dressing", "caesar salad dressing", "Соус Цезарь"],
  "italian-dressing": ["italian dressing", "italian salad dressing", "Итальянская заправка"],
  "cumin-ground": ["ground cumin", "comino molido", "cumin powder", "Кумин молотый"],
  "oregano": ["dried oregano", "orégano", "oregano leaves", "Орегано"],
  "bay-leaves": ["bay leaves", "hoja de laurel", "dried bay leaves", "Лавровый лист"],
  "cinnamon-sticks": ["cinnamon sticks", "canela en rama", "whole cinnamon", "Корица палочки"],
  "turmeric": ["turmeric powder", "cúrcuma molida", "ground turmeric", "Куркума молотая"],
  "onion-powder": ["onion powder", "cebolla en polvo", "dried onion powder", "Лук сушеный молотый"],
  "garlic-powder": ["garlic powder", "ajo en polvo", "dried garlic powder", "Чеснок сушеный молотый"],
};

export const AVERAGE_WEIGHTS = {
  tomatoes:        150,   // 1 средний помидор ≈ 150 g
  onion:           150,
  garlic:           50,   // головка
  bellPeppers:     150,
  cucumber:        300,
  zucchini:        250,
  banana:          120,
  apple:           150,
  orange:          150,
  avocado:        200,
  sweetPotato:     180,
  cabbage:         750,
  lime:             70,
  egg:              50,   // 1 шт. М
};

// Average weight (grams) of one "head" / whole unit for products that ship
// as individual heads/bulbs/loaves. Used by canonical-unit coercion in
// `consolidateByProductId` (count <-> weight) to merge duplicate rows when the
// same Typesense product arrives in both a count-based and weight-based entry.
export const HEAD_WEIGHTS = {
  garlic:    50,    // 1 head of garlic ≈ 50g
  lemon:    100,    // 1 lemon ≈ 100g
  lime:      70,    // 1 lime ≈ 70g
  lettuce:  300,    // 1 head of lettuce ≈ 300g
  romaine:  300,
  iceberg:  400,
  cabbage:  750,    // 1 head of cabbage ≈ 750g
  baguette: 250,    // 1 baguette ≈ 250g
  bread:    500,    // 1 loaf of sliced bread ≈ 500g
  onion:    150,
  tomato:   150,
  apple:    150,
  orange:   150,
};

// Canonical categories for the app
export const CATEGORIES = [
  'Meat & Seafood',
  'Produce',
  'Dairy, Alternatives & Eggs',
  'Grains & Pasta',
  'Frozen',            // Added
  'Bakery',            // Added
  'Refrigerated',      // Added (to replace 'Fridge' for more general use)
  'Pantry',
  'Condiments',
  'Other' // Backup category, please avoid to use
];

/**
 * Normalize any category string to one of the canonical categories.
 * Falls back to 'Other' if not recognized.
 */
export function normalizeCategory(category) {
  if (!category) return CATEGORIES[9]; // 'Other'
  const lower = category.toLowerCase();
  
  // Meat & Seafood
  if (lower.includes('meat') || lower.includes('seafood') || lower.includes('protein') || 
      lower.includes('beef') || lower.includes('chicken') || lower.includes('fish') || 
      lower.includes('pork') || lower.includes('turkey') || lower.includes('lamb')) return CATEGORIES[0];
  
  // Produce
  if (lower.includes('produce') || lower.includes('fruit') || lower.includes('vegetable') || 
      lower.includes('fresh') || lower.includes('organic')) return CATEGORIES[1];
  
  // Dairy, Alternatives & Eggs
  if (lower.includes('dairy') || lower.includes('egg') || lower.includes('alternatives') || 
      lower.includes('milk') || lower.includes('cheese') || lower.includes('yogurt') || 
      lower.includes('butter') || lower.includes('cream')) return CATEGORIES[2];
  
  // Grains & Pasta
  if (lower.includes('grain') || lower.includes('pasta') || lower.includes('cereal') || 
      lower.includes('rice') || lower.includes('noodle') || lower.includes('oats') || 
      lower.includes('quinoa') || lower.includes('round rice')) return CATEGORIES[3];
  
  // Frozen
  if (lower.includes('frozen') || lower.includes('ice cream') || lower.includes('freezer')) return CATEGORIES[4];
  
  // Bakery
  if (lower.includes('bakery') || lower.includes('bread') || lower.includes('baked') || 
      lower.includes('pastry') || lower.includes('cake') || lower.includes('muffin') || 
      lower.includes('bagel') || lower.includes('croissant')) return CATEGORIES[5];
  
  // Refrigerated (items that need refrigeration but aren't dairy/meat)
  if (lower.includes('refrigerated') || lower.includes('fridge') || lower.includes('chilled') || 
      lower.includes('fresh pasta') || lower.includes('deli')) return CATEGORIES[6];
  
  // Pantry
  if (lower.includes('pantry') || lower.includes('oil') || lower.includes('sugar') || 
      lower.includes('honey') || lower.includes('coffee') || lower.includes('tea') || 
      lower.includes('flour') || lower.includes('baking') || lower.includes('canned') || 
      lower.includes('dried') || lower.includes('nuts') || lower.includes('snack')) return CATEGORIES[7];
  
  // Condiments
  if (lower.includes('condiment') || lower.includes('sauce') || lower.includes('dressing') || 
      lower.includes('spice') || lower.includes('seasoning') || lower.includes('marinade') || 
      lower.includes('vinegar') || lower.includes('mustard') || lower.includes('ketchup')) return CATEGORIES[8];
  
  // Fallback to Other
  return CATEGORIES[9];
}



// PRODUCT_METADATA with reorganized categories, marketWeight, and image properties.
// Populated from estonia.js and previous data.
// Categories are aligned with the approved CATEGORIES list.
// avgWeight has been reviewed and corrected for all entries.
export const PRODUCT_METADATA = {
  // --- Produce ---
  "tomatoes": {
    category: "Produce",
    image: "tomatoes.jpg",
    storage: "pantry",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["tomato", "fresh tomatoes", "roma tomato", "plum tomatoes", "large tomato", "Томат Бифштекс", "Томаты Сливовидные", "Томат Розовый", "Томаты на ветке"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 270, imperial: 9.5 }
  },
  "cherry-tomatoes": {
    category: "Produce",
    image: "cherry-tomatoes.jpg",
    storage: "pantry",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["cherry tomatoes", "grape tomatoes", "small tomatoes", "Томаты черри", "Томаты черри на ветке"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "potatoes": {
    category: "Produce",
    image: "potatoes.jpg",
    storage: "pantry",
    shelfLifeDays: 90,
    density: null,
    synonyms: ["potato", "baking potatoes", "russet potatoes", "white potatoes", "Картофель"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 200, imperial: 7.1 }
  },
  "onions": {
    category: "Produce",
    image: "onions.jpg",
    storage: "pantry",
    shelfLifeDays: 60,
    density: null,
    synonyms: ["onion", "yellow onion", "white onion", "red onion", "Лук репчатый"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "carrots": {
    category: "Produce",
    image: "carrots.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["carrot", "orange carrots", "baby carrots", "Морковь"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 100, imperial: 3.5 }
  },
  "cucumber": {
    category: "Produce",
    image: "cucumber.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["cucumbers", "english cucumber", "fresh cucumber", "Огурец"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 300, imperial: 10.6 }
  },
  "bell-peppers": {
    category: "Produce",
    image: "bell-peppers.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["bell pepper", "red pepper", "green pepper", "yellow pepper", "pimiento", "Перец зеленый", "Перец красный", "Перец желтый"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "broccoli": {
    category: "Produce",
    image: "broccoli.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["broccoli", "fresh broccoli", "green broccoli", "brócoli", "Брокколи"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 400, imperial: 14.1 }
  },
  "zucchini": {
    category: "Produce",
    image: "zucchini.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["courgette", "green squash", "summer squash", "calabacín", "Кабачок"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 250, imperial: 8.8 }
  },
  "sweet-potatoes": {
    category: "Produce",
    image: "sweet-potatoes.jpg",
    storage: "pantry",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["sweet potato", "sweet potatoes", "yam", "boniato", "Батат"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 180, imperial: 6.3 }
  },
  "eggplant": {
    category: "Produce",
    image: "eggplant.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["eggplant", "aubergine", "purple eggplant", "berenjena", "Баклажан"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 250, imperial: 8.8 }
  },
  "lemons": {
    category: "Produce",
    image: "lemons.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["lemon", "lemons", "limones", "Лимоны"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 80, imperial: 2.8 }
  },
  "mushrooms": {
    category: "Produce",
    image: "mushrooms.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["mushroom", "white mushrooms", "cremini mushrooms", "button mushrooms", "champiñones", "Шампиньоны"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "garlic": {
    category: "Produce",
    image: "garlic.jpg",
    storage: "pantry",
    shelfLifeDays: 90,
    density: null,
    synonyms: ["garlic head", "garlic clove", "fresh garlic", "ajos", "cabeza de ajo", "Чеснок"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 50, imperial: 1.8 },
    cloveWeight: { metric: 5, imperial: 0.18 }
  },
  "ginger": {
    category: "Produce",
    image: "ginger.jpg",
    storage: "pantry",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["ginger root", "fresh ginger", "jengibre", "Корень имбиря"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "parsley-fresh": {
    category: "Produce",
    image: "parsley-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["parsley", "italian parsley", "flat leaf parsley", "curly parsley", "perejil fresco", "Петрушка свежая"],
    marketWeight: { metric: 'bunch', imperial: 'bunch' },
    avgWeight: { metric: 30, imperial: 1.1 }
  },
  "fresh-strawberries": {
    category: "Produce",
    image: "fresh-strawberries.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["fresh strawberries", "strawberries", "fresas", "Свежая клубника"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "fresh-blueberries": {
    category: "Produce",
    image: "fresh-blueberries.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["fresh blueberries", "blueberries", "arándanos", "Свежая голубика"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "avocado": {
    category: "Produce",
    image: "avocado.jpg",
    storage: "pantry",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["avocado", "hass avocado", "Авокадо"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 180, imperial: 6.3 }
  },
  "broccoli-florets-fresh": {
    category: "Produce",
    image: "broccoli-florets-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 4,
    density: null,
    synonyms: ["broccoli florets", "fresh broccoli florets", "chopped broccoli", "brócoli en ramilletes", "Соцветия брокколи свежие"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "lettuce": {
    category: "Produce",
    image: "lettuce.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["romaine lettuce", "iceberg lettuce", "lettuce head", "Салат Айсберг"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 300, imperial: 10.6 }
  },
  "fresh-basil": {
    category: "Produce",
    image: "fresh-basil.jpg",
    storage: "pantry",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["basil", "sweet basil", "basil leaves", "fresh herbs", "Базилик свежий"],
    marketWeight: { metric: 'bunch', imperial: 'bunch' },
    avgWeight: { metric: 20, imperial: 0.7 }
  },
  "bananas": {
    category: "Produce",
    image: "bananas.jpg",
    storage: "pantry",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["banana", "plátano", "Бананы"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 120, imperial: 4.2 }
  },
  "apples": {
    category: "Produce",
    image: "apples.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["apple", "manzana", "Яблоки"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "oranges": {
    category: "Produce",
    image: "oranges.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["orange", "naranja", "Апельсины"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "asparagus": {
    category: "Produce",
    image: "asparagus.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["asparagus", "fresh asparagus", "Спаржа"],
    marketWeight: { metric: 'bunch', imperial: 'bunch' },
    avgWeight: { metric: 250, imperial: 8.8 }
  },
  "cilantro-fresh": {
    category: "Produce",
    image: "cilantro-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: 0.05,
    synonyms: ["cilantro", "fresh cilantro", "coriander leaves", "fresh coriander", "Кинза свежая"],
    marketWeight: { metric: 'bunch', imperial: 'bunch' },
    avgWeight: { metric: 40, imperial: 1.4 }
  },
  "lime": {
    category: "Produce",
    image: "lime.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["lime", "limes", "Лайм"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 70, imperial: 2.5 }
  },
  "cabbage": {
    category: "Produce",
    image: "cabbage.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: null,
    synonyms: ["cabbage", "green cabbage", "white cabbage", "Капуста белокочанная"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 750, imperial: 26.5 }
  },
  "spinach-fresh": {
    category: "Produce",
    image: "spinach-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: 0.125,
    synonyms: ["spinach", "fresh spinach", "Шпинат свежий"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: { metric: 100, imperial: 3.5 }
  },
  "mixed-berries-fresh": {
    category: "Produce",
    image: "mixed-berries-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: 0.65,
    synonyms: ["mixed berries", "fresh berry mix", "berry medley", "Ягодная смесь свежая"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: { metric: 300, imperial: 10.6 }
  },

  // --- Meat & Seafood ---
  "chicken-whole": {
    category: "Meat & Seafood",
    image: "chicken-whole.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["whole chicken", "pollo entero", "Курица целая"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "chicken-breast": {
    category: "Meat & Seafood",
    image: "chicken-breast.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["chicken", "chicken breast", "boneless chicken", "chicken fillet", "pechuga de pollo", "Филе куриной грудки"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 200, imperial: 7.1 }
  },
  "chicken-thighs": {
    category: "Meat & Seafood",
    image: "chicken-thighs.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["chicken thighs", "muslos de pollo", "chicken leg quarters", "Куриные бедра"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "pork-loin-fillets": {
    category: "Meat & Seafood",
    image: "pork-loin-fillets.jpg",
    storage: "fridge",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["pork chops", "pork loin", "pork cuts", "filetes de lomo de cerdo", "Филе свиной вырезки"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "minced-beef": {
    category: "Meat & Seafood",
    image: "minced-beef.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["beef mince", "minced beef", "ground beef", "carne picada de vacuno", "Фарш говяжий"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "sausages-pork-fresh": {
    category: "Meat & Seafood",
    image: "sausages-pork-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["fresh pork sausages", "salchichas frescas de cerdo", "pork sausages", "Сосиски свежие свиные"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "ham-cooked-sliced": {
    category: "Meat & Seafood",
    image: "ham-cooked-sliced.jpg",
    storage: "fridge",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["sliced cooked ham", "jamón cocido en lonchas", "york ham slices", "Ветчина нарезанная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "beef-steak": {
    category: "Meat & Seafood",
    image: "beef-steak.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["beef steak", "filetes de ternera", "beef slices", "Говяжий стейк"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 150, imperial: 5.3 }
  },
  "pork-ribs": {
    category: "Meat & Seafood",
    image: "pork-ribs.jpg",
    storage: "fridge",
    shelfLifeDays: 4,
    density: null,
    synonyms: ["pork ribs", "costillas de cerdo", "Свиные ребрышки"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "salmon-fillet-fresh": {
    category: "Meat & Seafood",
    image: "salmon-fillet-fresh.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["fresh salmon fillet", "salmón fresco", "filete de salmón fresco", "Филе лосося свежее"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "pork-shoulder": {
    category: "Meat & Seafood",
    image: "pork-shoulder.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["pork shoulder", "pork butt", "paleta de cerdo", "boston butt", "Свиная лопатка"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "beef-chuck": {
    category: "Meat & Seafood",
    image: "beef-chuck.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["beef chuck", "chuck roast", "stewing beef", "carne para guisar", "aguja de ternera", "Говяжья лопатка"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "fresh-prawns": {
    category: "Meat & Seafood",
    image: "fresh-prawns.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["prawns", "shrimp", "shrimps", "fresh shrimp", "seafood", "Креветки свежие"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: { metric: 15, imperial: 0.5 }
  },
  "mixed-seafood": {
    category: "Meat & Seafood",
    image: "mixed-seafood.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["mixed seafood", "seafood mix", "seafood medley", "Морской коктейль"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "chorizo": {
    category: "Meat & Seafood",
    image: "chorizo.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["chorizo", "spanish sausage", "spicy sausage", "cured meat", "Чоризо"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "serrano-ham": {
    category: "Meat & Seafood",
    image: "serrano-ham.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["serrano ham", "jamon serrano", "cured ham", "spanish ham", "jamón", "Хамон Серрано"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "white-fish-fillet": {
    category: "Meat & Seafood",
    image: "white-fish-fillet.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["white fish fillet", "white fish", "sea bass fillet", "cod fillet", "generic fish fillet", "Филе белой рыбы"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "mussels": {
    category: "Meat & Seafood",
    image: "mussels.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["mussels", "mussel", "black mussels", "mejillones", "seafood mussels", "Мидии"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "calamari": {
    category: "Meat & Seafood",
    image: "calamari.jpg",
    storage: "fridge",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["calamari", "squid", "squid rings", "fried calamari", "calamares", "Кальмары"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "pancetta": {
    category: "Meat & Seafood",
    image: "pancetta.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["pancetta", "italian bacon", "Панчетта"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "beef-strips": {
    category: "Meat & Seafood",
    image: "beef-strips.jpg",
    storage: "fridge",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["beef strips", "strip steak", "sliced beef", "Говядина для бефстроганова"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },

  // --- Frozen ---
  "salmon-fillet-frozen": {
    category: "Frozen",
    image: "salmon-fillet-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen salmon fillet", "salmón congelado", "filete de salmón congelado", "Филе лосося замороженное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "sea bass-fillet-frozen": {
    category: "Frozen",
    image: "sea bass-fillet-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen sea bass fillets", "merluza congelada", "filetes de merluza", "Филе тилапии замороженное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "prawns-frozen": {
    category: "Frozen",
    image: "prawns-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["prawns", "frozen shrimp", "seafood", "gambones congelados", "Креветки замороженные"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: { metric: 15, imperial: 0.5 }
  },
  "cod-fillet-frozen": {
    category: "Frozen",
    image: "cod-fillet-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen cod fillet", "filetes de bacalao ultracongelados", "cod fish frozen", "Филе трески замороженное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "spinach-frozen": {
    category: "Frozen",
    image: "spinach-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen spinach", "espinacas congeladas", "Шпинат замороженный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "mixed-vegetables-frozen": {
    category: "Frozen",
    image: "mixed-vegetables-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen mixed vegetables", "verdura congelada", "menestra congelada", "Овощная смесь замороженная"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "green-beans-frozen": {
    category: "Frozen",
    image: "green-beans-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen green beans", "judía verde congelada", "Фасоль стручковая замороженная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "frozen-strawberries": {
    category: "Frozen",
    image: "frozen-strawberries.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen strawberries", "strawberries frozen", "fresas congeladas", "Клубника замороженная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "frozen-blueberries": {
    category: "Frozen",
    image: "frozen-blueberries.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen blueberries", "blueberries frozen", "arándanos congelados", "Голубика замороженная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "peas-frozen": {
    category: "Frozen",
    image: "peas-frozen.jpg",
    storage: "freezer",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["frozen peas", "peas", "garden peas", "guisantes congelados", "Горошек замороженный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },

  // --- Dairy, Alternatives & Eggs ---
  "eggs": {
    category: "Dairy, Alternatives & Eggs",
    image: "eggs.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: null,
    synonyms: ["egg", "medium eggs", "grade m eggs", "huevos", "Яйца", "Яйца крупные L", "Яйца средние M", "Яйца фермерские", "Яйца органические"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 60, imperial: 2.1 }
  },
  "milk-whole": {
    category: "Dairy, Alternatives & Eggs",
    image: "milk-whole.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.03,
    synonyms: ["whole milk", "full fat milk", "dairy milk", "leche entera", "Молоко цельное"],
    marketWeight: { metric: 'l', imperial: 'gal' }
  },
  "milk-2percent": {
    category: "Dairy, Alternatives & Eggs",
    image: "milk-2percent.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.03,
    synonyms: ["2% milk", "semi-skimmed milk", "leche semidesnatada", "Молоко 2%"],
    marketWeight: { metric: 'l', imperial: 'gal' },
    avgWeight: null
  },
  "milk-skim": {
    category: "Dairy, Alternatives & Eggs",
    image: "milk-skim.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.03,
    synonyms: ["skimmed milk", "leche desnatada", "Молоко обезжиренное"],
    marketWeight: { metric: 'l', imperial: 'gal' },
    avgWeight: null
  },
  "butter": {
    category: "Dairy, Alternatives & Eggs",
    image: "butter.jpg",
    storage: "fridge",
    shelfLifeDays: 90,
    density: 0.91,
    synonyms: ["butter", "mantequilla", "salted butter", "unsalted butter", "Масло сливочное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "cheese-sliced": {
    category: "Dairy, Alternatives & Eggs",
    image: "cheese-sliced.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["sliced cheese", "queso en lonchas", "sandwich cheese", "Сыр нарезанный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "cheese-shredded": {
    category: "Dairy, Alternatives & Eggs",
    image: "cheese-shredded.jpg",
    storage: "fridge",
    shelfLifeDays: 14,
    density: null,
    synonyms: ["grated cheese blend", "mixed grated cheese", "queso rallado", "Сыр тертый (смесь 4 сыра)"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "cheddar-cheese": {
    category: "Dairy, Alternatives & Eggs",
    image: "cheddar-cheese.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: null,
    synonyms: ["cheddar cheese", "queso cheddar", "block cheddar", "sliced cheddar", "Сыр чеддер"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "parmesan-grated": {
    category: "Dairy, Alternatives & Eggs",
    image: "parmesan-grated.jpg",
    storage: "fridge",
    shelfLifeDays: 60,
    density: 0.4,
    synonyms: ["parmigiano", "parmesan", "hard cheese", "grated parmesan", "queso parmesano rallado", "Сыр Пармезан тертый"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "cooking-cream": {
    category: "Dairy, Alternatives & Eggs",
    image: "cooking-cream.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.0,
    synonyms: ["cooking cream", "nata para cocinar", "light cream", "Сливки для готовки"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' }
  },
  "heavy-cream": {
    category: "Dairy, Alternatives & Eggs",
    image: "heavy-cream.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.0,
    synonyms: ["heavy cream", "nata para montar", "whipping cream", "Сливки для взбивания"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' }
  },
  "yogurt-natural": {
    category: "Dairy, Alternatives & Eggs",
    image: "yogurt-natural.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: 1.04,
    synonyms: ["yogurt", "natural yogurt", "plain yogurt", "yogur natural", "Йогурт натуральный"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "condensed-milk": {
    category: "Dairy, Alternatives & Eggs",
    image: "condensed-milk.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.3,
    synonyms: ["condensed milk", "leche condensada", "sweetened condensed milk", "Молоко сгущенное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "mozzarella-cheese": {
    category: "Dairy, Alternatives & Eggs",
    image: "mozzarella-cheese.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: null,
    synonyms: ["mozzarella cheese", "mozzarella", "fresh mozzarella", "italian cheese", "pizza cheese", "bola de mozzarella", "Сыр Моцарелла"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: { metric: 125, imperial: 4.4 }
  },
  "cream-cheese": {
    category: "Dairy, Alternatives & Eggs",
    image: "cream-cheese.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["cream cheese", "queso crema", "soft cheese", "Сливочный сыр"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "greek-yogurt": {
    category: "Dairy, Alternatives & Eggs",
    image: "greek-yogurt.jpg",
    storage: "fridge",
    shelfLifeDays: 21,
    density: null,
    synonyms: ["greek yogurt", "strained yogurt", "yogurt", "Греческий йогурт"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "tofu": {
    category: "Dairy, Alternatives & Eggs",
    image: "tofu.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["tofu", "firm tofu", "extra‑firm tofu", "soy bean curd", "Тофу"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: { metric: 250, imperial: 8.8 }
  },
  "emmental-cheese": {
    category: "Dairy, Alternatives & Eggs",
    image: "emmental-cheese.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["emmental cheese", "emmental", "swiss cheese", "holey cheese", "Сыр Эмменталь"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "feta-cheese": {
    category: "Dairy, Alternatives & Eggs",
    image: "feta-cheese.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["feta cheese", "feta", "greek cheese", "crumbly cheese", "Сыр Фета"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },

  // --- Bakery ---
  "bread-loaf-sliced": {
    category: "Bakery",
    image: "bread-loaf-sliced.jpg",
    storage: "pantry",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["white bread", "bread loaf", "sandwich bread", "toast bread", "pan de molde", "Хлеб тостовый"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 500, imperial: 17.6 }
  },
  "baguette": {
    category: "Bakery",
    image: "baguette.jpg",
    storage: "pantry",
    shelfLifeDays: 2,
    density: null,
    synonyms: ["french bread", "bread stick", "crusty bread", "barra de pan", "Багет"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 200, imperial: 7.1 }
  },
  "breadcrumbs": {
    category: "Bakery",
    image: "breadcrumbs.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 0.4,
    synonyms: ["breadcrumbs", "pan rallado", "dry breadcrumbs", "Панировочные сухари"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "rye-bread-sliced": {
    category: "Bakery",
    image: "rye-bread-sliced.jpg",
    storage: "pantry",
    shelfLifeDays: 7,
    density: null,
    synonyms: ["rye bread", "dark rye bread", "pan de centeno", "sliced rye bread", "Хлеб ржаной нарезанной"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 500, imperial: 17.6 }
  },
  "croissants": {
    category: "Bakery",
    image: "croissants.jpg",
    storage: "pantry",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["croissant", "french pastry", "breakfast pastry", "Круассан"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 60, imperial: 2.1 }
  },
  "whole-wheat-bread": {
    category: "Bakery",
    image: "whole-wheat-bread.jpg",
    storage: "pantry",
    shelfLifeDays: 5,
    density: null,
    synonyms: ["whole wheat bread", "whole‑grain bread", "grain bread", "wheat bread", "Хлеб цельнозерновой"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 500, imperial: 17.6 }
  },
  "ciabatta-bread": {
    category: "Bakery",
    image: "ciabatta-bread.jpg",
    storage: "pantry",
    shelfLifeDays: 3,
    density: null,
    synonyms: ["ciabatta", "ciabatta bread", "ciabatta loaf", "Чиабатта"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: { metric: 250, imperial: 8.8 }
  },

  // --- Refrigerated ---
  "puff-pastry": {
    category: "Refrigerated",
    image: "puff-pastry.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["puff pastry sheet", "hojaldre fresco", "pastry dough", "Тесто слоеное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "shortcrust-pastry": {
    category: "Refrigerated",
    image: "shortcrust-pastry.jpg",
    storage: "fridge",
    shelfLifeDays: 30,
    density: null,
    synonyms: ["shortcrust pastry sheet", "masa quebrada fresca", "pâte brisée", "Тесто песочное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },

  // --- Grains & Pasta ---
  "rice-short-grain": {
    category: "Grains & Pasta",
    image: "rice-short-grain.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["rice", "round grain rice", "arroz redondo", "Рис круглый"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "rice-long-grain": {
    category: "Grains & Pasta",
    image: "rice-long-grain.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["long grain rice", "arroz largo", "white rice", "Рис длиннозерный белый"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "rice-paella": {
    category: "Grains & Pasta",
    image: "rice-paella.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["paella rice", "arroz para paella", "arroz bomba", "short grain rice for paella", "Рис для паэльи"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "pasta-spaghetti": {
    category: "Grains & Pasta",
    image: "pasta-spaghetti.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["pasta", "spaghetti", "italian pasta", "long pasta", "espagueti", "Спагетти"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "pasta-macaroni": {
    category: "Grains & Pasta",
    image: "pasta-macaroni.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["pasta", "macaroni", "elbow pasta", "short pasta", "macarrones", "Макароны"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "pasta-fusilli": {
    category: "Grains & Pasta",
    image: "pasta-fusilli.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["fusilli pasta", "pasta espirales", "spiral pasta", "dry pasta", "Макароны фузилли"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "rice-brown": {
    category: "Grains & Pasta",
    image: "rice-brown.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.85,
    synonyms: ["brown rice", "whole‑grain rice", "long‑grain brown rice", "Коричневый рис"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "quinoa": {
    category: "Grains & Pasta",
    image: "quinoa.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.7,
    synonyms: ["quinoa", "whole grain quinoa", "white quinoa", "quinoa seeds", "Киноа"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "wheat-pasta-generic": {
    category: "Grains & Pasta",
    image: "wheat-pasta-generic.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["wheat pasta", "whole wheat pasta", "pasta integral", "whole grain pasta", "Пшеничные макароны"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "pasta-whole-wheat": {
    category: "Grains & Pasta",
    image: "pasta-whole-wheat.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["wheat pasta", "whole wheat pasta", "pasta integral", "whole grain pasta"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "mexican-rice": {
    category: "Grains & Pasta",
    image: "mexican-rice.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["mexican rice", "spanish rice", "mex‑rice mix", "Рис по-мексикански"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "arborio-rice": {
    category: "Grains & Pasta",
    image: "arborio-rice.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["arborio rice", "risotto rice", "italian rice", "risotto grain", "Рис Арборио"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },

  // --- Pantry ---
  "rolled-oats": {
    category: "Pantry",
    image: "rolled-oats.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 0.4,
    synonyms: ["rolled oats", "copos de avena", "oats", "porridge oats", "Овсяные хлопья"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "tuna-in-oil": {
    category: "Pantry",
    image: "tuna-in-oil.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["canned tuna in oil", "atún en aceite", "tuna chunks in oil", "Тунец в масле"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "tuna-in-brine": {
    category: "Pantry",
    image: "tuna-in-brine.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["canned tuna in brine", "atún al natural", "tuna chunks in water", "Тунец в собственном соку"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "sardines-canned": {
    category: "Pantry",
    image: "sardines-canned.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.9,
    synonyms: ["canned sardines", "sardinas en lata", "sardines in oil", "Сардины в масле"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "lentils-cooked": {
    category: "Pantry",
    image: "lentils-cooked.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["cooked lentils", "lenteja cocida", "canned lentils", "Чечевица вареная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "lentils-dry": {
    category: "Pantry",
    image: "lentils-dry.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.8,
    synonyms: ["dry lentils", "lenteja seca", "pardina lentils", "Чечевица сухая"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "chickpeas-cooked": {
    category: "Pantry",
    image: "chickpeas-cooked.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["chickpeas", "garbanzo beans", "canned chickpeas", "garbanzo cocido", "Нут вареный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "chickpeas-dry": {
    category: "Pantry",
    image: "chickpeas-dry.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.8,
    synonyms: ["dry chickpeas", "garbanzo seco", "Нут сухой"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "white-beans-cooked": {
    category: "Pantry",
    image: "white-beans-cooked.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["cooked white beans", "alubia blanca cocida", "canned white beans", "Фасоль белая вареная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "white-beans-dry": {
    category: "Pantry",
    image: "white-beans-dry.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.8,
    synonyms: ["dry white beans", "alubia blanca seca", "fabada beans dry", "Фасоль белая сухая"],
    marketWeight: { metric: 'kg', imperial: 'lb' },
    avgWeight: null
  },
  "sugar-white": {
    category: "Pantry",
    image: "sugar-white.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.85,
    synonyms: ["sugar", "granulated sugar", "table sugar", "azúcar blanco", "Сахар белый"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "sugar-brown": {
    category: "Pantry",
    image: "sugar-brown.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.85,
    synonyms: ["brown sugar", "azúcar moreno", "dark brown sugar", "light brown sugar", "Сахар коричневый"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "flour-wheat": {
    category: "Pantry",
    image: "flour-wheat.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 0.55,
    synonyms: ["all purpose flour", "plain flour", "baking flour", "harina de trigo", "wheat flour", "Мука пшеничная"],
    marketWeight: { metric: 'kg', imperial: 'lb' }
  },
  "honey": {
    category: "Pantry",
    image: "honey.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.42,
    synonyms: ["honey", "miel", "bee honey", "Мед цветочный"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "jam-strawberry": {
    category: "Pantry",
    image: "jam-strawberry.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.3,
    synonyms: ["strawberry jam", "mermelada de fresa", "fruit preserves", "Варенье клубничное"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "green-olives-pitted": {
    category: "Pantry",
    image: "green-olives-pitted.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.0,
    synonyms: ["pitted green olives", "aceitunas verdes sin hueso", "olives canned", "Оливки зеленые без косточек"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "tomato-paste-concentrated": {
    category: "Pantry",
    image: "tomato-paste-concentrated.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.2,
    synonyms: ["concentrated tomato paste", "concentrado de tomate", "tomato concentrate", "Томатная паста"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "peas-canned": {
    category: "Pantry",
    image: "peas-canned.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.0,
    synonyms: ["canned peas", "guisantes en conserva", "peas in brine", "Горошек консервированный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "sweetcorn-canned": {
    category: "Pantry",
    image: "sweetcorn-canned.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.0,
    synonyms: ["canned sweetcorn", "maíz dulce en conserva", "sweetcorn in brine", "Кукуруза консервированная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "stock-cubes-chicken": {
    category: "Pantry",
    image: "stock-cubes-chicken.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["chicken stock cubes", "chicken bouillon cubes", "pastillas de caldo de pollo", "Кубики куриного бульона"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: null
  },
  "stock-cubes-vegetable": {
    category: "Pantry",
    image: "stock-cubes-vegetable.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["vegetable stock cubes", "vegetable bouillon cubes", "pastillas de caldo de verduras", "Кубики овощного бульона"],
    marketWeight: { metric: 'unit', imperial: 'unit' },
    avgWeight: null
  },
  "vanilla-extract": {
    category: "Pantry",
    image: "vanilla-extract.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.95,
    synonyms: ["vanilla extract", "aroma de vainilla", "vanilla essence", "Ванильный экстракт"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' },
    avgWeight: null
  },
  "baking-powder": {
    category: "Pantry",
    image: "baking-powder.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 0.8,
    synonyms: ["baking powder", "levadura en polvo", "Разрыхлитель теста"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "cocoa-powder-unsweetened": {
    category: "Pantry",
    image: "cocoa-powder-unsweetened.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.5,
    synonyms: ["unsweetened cocoa powder", "cacao puro en polvo", "baking cocoa", "Какао-порошок"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "almonds": {
    category: "Pantry",
    image: "almonds.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["almonds", "raw almonds", "shelled almonds", "almendra cruda", "almendras", "Миндаль сырой"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "walnuts": {
    category: "Pantry",
    image: "walnuts.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["walnuts", "shelled walnuts", "raw walnuts", "nuez pelada", "nueces", "Грецкие орехи"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "hazelnuts": {
    category: "Pantry",
    image: "hazelnuts.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: null,
    synonyms: ["hazelnuts", "avellanas", "avellana pelada", "shelled hazelnuts", "Фундук очищенный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "pine-nuts": {
    category: "Pantry",
    image: "pine-nuts.jpg",
    storage: "pantry",
    shelfLifeDays: 90,
    density: 0.5,
    synonyms: ["pine nuts", "piñones", "Кедровые орехи"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "lemon-juice-bottled": {
    category: "Pantry",
    image: "lemon-juice-bottled.jpg",
    storage: "pantry",
    shelfLifeDays: 180,
    density: 1.03,
    synonyms: ["lemon juice", "bottled lemon juice", "zumo de limón", "lemon juice concentrate", "Лимонный сок"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' },
    avgWeight: null
  },
  "vegetable-broth-liquid": {
    category: "Pantry",
    image: "vegetable-broth-liquid.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["vegetable broth", "vegetable stock", "veggie broth", "caldo de verduras", "liquid vegetable stock", "Овощной бульон"],
    marketWeight: { metric: 'l', imperial: 'gal' },
    avgWeight: null
  },
  "peas-dry": {
    category: "Pantry",
    image: "peas-dry.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.8,
    synonyms: ["dried peas", "split peas", "Горох сушеный"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "beef-broth-liquid": {
    category: "Pantry",
    image: "beef-broth-liquid.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["beef broth", "beef stock", "caldo de carne", "liquid beef stock", "Говяжий бульон"],
    marketWeight: { metric: 'l', imperial: 'gal' },
    avgWeight: null
  },
  "chia-seeds": {
    category: "Pantry",
    image: "chia-seeds.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.7,
    synonyms: ["chia seeds", "семена чиа"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "dried-kidney-beans": {
    category: "Pantry",
    image: "dried-kidney-beans.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.8,
    synonyms: ["dried kidney beans", "red kidney beans", "Красная фасоль сушеная"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "chicken-broth": {
    category: "Pantry",
    image: "chicken-broth.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: 1.0,
    synonyms: ["chicken stock", "broth", "stock", "caldo de pollo", "Куриный бульон"],
    marketWeight: { metric: 'l', imperial: 'gal' }
  },
  "coffee-ground": {
    category: "Pantry",
    image: "coffee-ground.jpg",
    storage: "pantry",
    shelfLifeDays: 365,
    density: null,
    synonyms: ["coffee", "ground coffee", "café molido", "Кофе молотый"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "tea-bags": {
    category: "Pantry",
    image: "tea-bags.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["tea", "tea bags", "té", "Чай в пакетиках"],
    marketWeight: { metric: 'unit', imperial: 'unit' }
  },
  "saffron": {
    category: "Pantry",
    image: "saffron.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["azafrán", "spice", "saffron spice", "saffron threads", "saffron", "Шафран"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "cinnamon-ground": {
    category: "Pantry",
    image: "cinnamon-ground.jpg",
    storage: "pantry",
    shelfLifeDays: 1095,
    density: 0.56,
    synonyms: ["cinnamon", "ground cinnamon", "cinnamon powder", "Корица молотая"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "maple-syrup": {
    category: "Pantry",
    image: "maple-syrup.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.32,
    synonyms: ["maple syrup", "Кленовый сироп"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' },
    avgWeight: null
  },

  // --- Condiments ---
  "salt": {
    category: "Condiments",
    image: "salt.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.2,
    synonyms: ["salt", "sea salt", "cooking salt", "table salt", "sal marina", "Соль морская мелкая"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "black-pepper-ground": {
    category: "Condiments",
    image: "black-pepper-ground.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 0.46,
    synonyms: ["black pepper", "ground pepper", "pimienta negra molida", "Перец черный молотый"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "vinegar-white-wine": {
    category: "Condiments",
    image: "vinegar-white-wine.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.0,
    synonyms: ["vinegar", "white wine vinegar", "vinagre de vino blanco", "Уксус винный белый"],
    marketWeight: { metric: 'l', imperial: 'gal' }
  },
  "mayonnaise": {
    category: "Condiments",
    image: "mayonnaise.jpg",
    storage: "fridge",
    shelfLifeDays: 180,
    density: 0.96,
    synonyms: ["mayo", "creamy mayonnaise", "sandwich spread", "mayonesa", "Майонез"],
    marketWeight: { metric: 'g', imperial: 'oz' }
  },
  "paprika-sweet": {
    category: "Condiments",
    image: "paprika-sweet.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["sweet paprika", "pimentón dulce", "spanish paprika", "Паприка сладкая"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "soy-sauce": {
    category: "Condiments",
    image: "soy-sauce.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: 1.15,
    synonyms: ["soy sauce", "salsa de soja", "shoyu", "tamari", "Соевый соус"],
    marketWeight: { metric: 'ml', imperial: 'fl oz' },
    avgWeight: null
  },
  "olive-oil-extra-virgin": {
    category: "Pantry",
    image: "olive-oil-extra-virgin.jpg",
    storage: "pantry",
    shelfLifeDays: 730, // Unopened
    density: 0.92, // g/ml
    synonyms: ["olive oil", "extra virgin olive oil", "evoo", "aceite de oliva virgen extra"],
     marketWeight: {
      metric: 'l', // in liters (or ml/g)
      imperial: 'gal', // in gallons (or fl oz/oz)
    }
  },
  "red-pepper-flakes": {
    category: "Condiments",
    image: "red-pepper-flakes.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["red pepper flakes", "crushed red pepper", "chilli flakes", "Хлопья красного перца"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "herbs-de-provence": {
    category: "Condiments",
    image: "herbs-de-provence.jpg",
    storage: "pantry",
    shelfLifeDays: 730,
    density: null,
    synonyms: ["herbs de provence", "french herbs", "dried herbs", "herb mix", "herb blend", "Прованские травы"],
    marketWeight: { metric: 'g', imperial: 'oz' },
    avgWeight: null
  },
  "caesar-dressing": {
    category: "Condiments",
    image: "caesar-dressing.jpg",
    storage: "fridge",
    shelfLifeDays: 90,
    density: 0.96,
    synonyms: ["caesar dressing", "caesar salad dressing", "Соус Цезарь"],
    marketWeight: { metric: 'l', imperial: 'gal' }
  },
  "italian-dressing": {
    category: "Condiments",
    image: "italian-dressing.jpg",
    storage: "fridge",
    shelfLifeDays: 90,
    density: 0.95,
    synonyms: ["italian dressing", "italian salad dressing", "Итальянская заправка"],
    marketWeight: { metric: 'l', imperial: 'gal' }
  }
};